export const reflectionForms = {
  reflection_1: {
    label: "Reflexion zum Verstehen der Fabel",
    description: "Reflexion zum Verstehen der Fabel und zur Wortschatzarbeit.",

    fields: [
      {
        type: "info",
        label:
          "Hier musst du darüber nachdenken was du heute gemacht bzw. gelernt hast.",
      },

      // 📖 Neue Wörter
      {
        type: "list",
        name: "newWords",
        label: "Neue Wörter, die ich heute gelernt habe",
        rows: 3,
      },

      // 🤔 Rückblick
      {
        type: "textarea",
        name: "success",
        label: "Das ist mir gut gelungen",
      },
      {
        type: "textarea",
        name: "difficulty",
        label: "Das war schwierig für mich",
      },

      // Verständnis
      {
        type: "radio",
        name: "understanding",
        label: "Habe ich die Geschichte gut verstanden?",
        options: ["Nein", "fast alles verstanden", "Ja"],
      },
      {
        type: "textarea",
        name: "understandingDetails",
        label: "Wenn etwas schwierig in der Geschichte war, was genau?",
      },

      // Moral
      {
        type: "textarea",
        name: "moral",
        label: "Die Moral der Fabel ist für mich:",
      },

      // Wortschatz-Arbeit
      {
        type: "checkbox",
        name: "vocabWork",
        label:
          "Wortschatz-Arbeit – Was habe ich gemacht? (Du kannst mehrere ankreuzen)",
        options: [
          "unbekannte Wörter in die Wortwolke geschickt",
          "versucht, die Bedeutung aus dem Zusammenhang zu verstehen",
          "mit HexiLexi (Lexikon) die Bedeutung von unbekannten Wörtern herausgefunden",
          "neue Wörter und ihre Bedeutung aufgeschrieben",
        ],
      },

      // Wortverständnis
      {
        type: "checkbox",
        name: "wordUnderstanding",
        label:
          "Was hat mir geholfen die Bedeutung von Wörtern zu finden? (Du kannst mehrere ankreuzen)",
        options: [
          "durch Hinweise im Text die Bedeutung verstehen",
          "durch Weiterlesen im Text",
          "mithilfe von HexiLexi (Lexikon)",
          "durch eine Erklärung der Lehrkraft",
          "durch Hilfe von Mitschülern",
        ],
      },
    ],
  },

  reflection_2: {
    label: "Gestalten und Bild verbessern",
    description: "Feedback zur Illustration und Zusammenarbeit.",
    fields: [
      { type: "textarea", name: "success", label: "Das ist mir gut gelungen" },
      { type: "textarea", name: "difficulty", label: "Das war schwierig" },
      {
        type: "checkbox",
        name: "feedback",
        label: "Feedback-Kompetenz",
        options: [
          "gutes Feedback gegeben",
          "hilfreiches Feedback bekommen",
          "Bild nach Feedback verbessert",
        ],
      },
    ],
  },

  reflection_3: {
    label: "Lesefluessigkeit und Lesetheater",
    description: "Feedback zur lesefluessigkeit und Lesetheater.",
    fields: [
      { type: "textarea", name: "success", label: "Das ist mir gut gelungen" },
      { type: "textarea", name: "difficulty", label: "Das war schwierig" },
      {
        type: "checkbox",
        name: "reading",
        label: "Meine Leseflüssigkeit",
        options: [
          "genau (wenige Fehler)",
          "im passenden Tempo",
          "ausdrucksstark",
          "nach dem Üben verbessert",
        ],
      },
      {
        type: "checkbox",
        name: "performance",
        label: "Mein Auftritt im Readers Theater",
        options: [
          "deutlich und verständlich",
          "laut genug",
          "ausdrucksstark",
          "gut mit Gruppe abgestimmt",
          "besser als bei der Probe",
        ],
      },
    ],
  },

  reflection_4: {
    label: "Fabel verstehen und illustrieren",
    description: "Reflexion zur den fabel verstehen und illustrieren.",

    fields: [
      {
        type: "info",
        label: "Ich kann die Fabel verstehen und illustrieren.",
      },

      // 📖 Neue Wörter
      {
        type: "list",
        name: "newWords",
        label: "📖 Neue Wörter, die ich heute gelernt habe",
        rows: 3, // 👈 you can render 3 input rows
      },

      // 🤔 Rückblick
      {
        type: "textarea",
        name: "success",
        label: "1️ Das ist mir gut gelungen",
      },
      {
        type: "textarea",
        name: "difficulty",
        label: "2️ Das war schwierig für mich",
      },

      // Verständnis
      {
        type: "radio",
        name: "understanding",
        label: "3️ Habe ich die Geschichte gut verstanden?",
        options: ["Nein", "fast alles verstanden", "Ja"],
      },
      {
        type: "textarea",
        name: "understandingDetails",
        label: "Wenn etwas schwierig war, was genau?",
      },

      // Moral
      {
        type: "textarea",
        name: "moral",
        label: "🌟 Die Moral der Fabel ist für mich",
      },

      // Wortschatz-Arbeit
      {
        type: "checkbox",
        name: "vocabWork",
        label: "4️ Wortschatz-Arbeit (Du kannst mehrere ankreuzen)",
        options: [
          "unbekannte Wörter erkannt",
          "unbekannte Wörter in die Wortwolke geschickt",
          "Bedeutung aus dem Kontext verstanden",
          "mit HexiLexi gearbeitet",
          "neue Wörter aufgeschrieben und erklärt",
        ],
      },

      // Wortverständnis
      {
        type: "checkbox",
        name: "wordUnderstanding",
        label: "5️ So habe ich Wörter verstanden",
        options: [
          "durch Hinweise im Satz",
          "durch Weiterlesen im Text",
          "mithilfe von HexiLexi",
          "durch Lehrkraft",
          "durch Mitschüler",
        ],
      },

      // Illustration
      {
        type: "checkbox",
        name: "illustration",
        label: "6️ Meine Illustration ist …",
        options: [
          "passend zum Text",
          "logisch in der Reihenfolge",
          "ausdrucksstark (Gefühle sichtbar)",
        ],
      },
    ],
  },

  reflection_5: {
    label: "Reflexion zum Gestalten",
    description: "Reflexion zum Gestalten und zum Verbessern der Bilder (Illustrationen) durch Feedback.",
    fields: [
      {
        type: "info",
        label:
          "Hier denkst du darüber nach, was du beim Gestalten deiner Bilder gemacht und gelernt hast."
      }, 
      { type: "textarea", name: "success", label: "Das ist mir gut gelungen" },
      { type: "textarea", name: "difficulty", label: "Das war schwierig" },
      {
        type: "checkbox",
        name: "illustration_quality",
        label: "Mein Bild ist … (Du kannst mehrere ankreuzen)",
        options: [
          "passend zum Text",
          "logisch in der Reihenfolge",
          "ausdrucksstark (Gefühle gut sichtbar)",
        ],
      },
      {
        type: "checkbox",
        name: "feedback_competence",
        label:
          "Feedback-Kompetenz – Heute habe ich … (Du kannst mehrere ankreuzen)",
        options: [
          "gutes Feedback gegeben",
          "hilfreiches Feedback bekommen",
          "mein Bild nach Feedback verbessert",
        ],
      },
    ],
  },





  reflection_6: {
    label: "Reflexion zum Lesefluessigkeit und Lesetheater",
    description: "Reflexion zur Leseflüssigkeit, Lesetheater und Feedback.",
    fields: [
      {
        type: "info",
        label:
          "Hier denkst du darüber nach, wie gut du gelesen hast, welches Feedback du gegeben und bekommen hast und wie dein Auftritt im Lesetheater war."
      }, 
      { type: "textarea", name: "success", label: "Das ist mir gut gelungen" },
      { type: "textarea", name: "difficulty", label: "Das war schwierig" },
      {
        type: "checkbox",
        name: "reading",
        label: "Meine Leseflüssigkeit war … (Du kannst mehrere ankreuzen)",
        options: [
          "genau (wenige Fehler)",
          "im passenden Tempo",
          "ausdrucksstark (Gefühle gut hörbar)",
          "nach dem Üben verbessert",
        ],
      },
      {
        type: "checkbox",
        name: "feedback",
        label: "Feedback-Kompetenz – Heute habe ich … (Du kannst mehrere ankreuzen)",
        options: [
          "gutes Feedback gegeben",
          "hilfreiches Feedback bekommen",
          "mein Lesen nach dem Feedback verbessert",
        ],
      },
      {
        type: "checkbox",
        name: "performance",
        label: "Mein Auftritt im Lesetheater war … (Du kannst mehrere ankreuzen)",
        options: [
          "deutlich und verständlich",
          "laut genug",
          "ausdrucksstark (Gefühle gut hörbar)",
          "gut mit meiner Gruppe abgestimmt",
          "besser als bei der Probe",
        ],
      },
    ],
  },














};
